import Sheet from './Sheet';

// Mirrors iOS HowToGuideView — a bottom sheet with a title, subtitle, and a
// list of icon + title + detail steps. steps: [{ Icon, title, detail }]
export default function HelpSheet({ open, onClose, title, subtitle, steps }) {
  return (
    <Sheet open={open} onClose={onClose} title={title}>
      {subtitle && <p className="px-4 pb-3 text-sm text-gray-500">{subtitle}</p>}
      <div className="px-4 pb-6 space-y-4">
        {steps.map(({ Icon, title: stepTitle, detail }) => (
          <div key={stepTitle} className="flex gap-3">
            <div className="w-9 h-9 rounded-full bg-orange-50 flex items-center justify-center shrink-0">
              <Icon size={18} className="text-[#FF6B35]" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">{stepTitle}</p>
              <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{detail}</p>
            </div>
          </div>
        ))}
      </div>
    </Sheet>
  );
}
